import { capitalize } from 'lodash'
import { getRequest, postRequest } from '.'

export const getSearchResults = async <T>(
  terms: string,
  realmScope?: wowaudit.Realm,
  searchType?: 'character' | 'guild' | 'community',
): Promise<T[]> => {
  const params = new URLSearchParams({
    terms,
    ...(realmScope && { realm_id: realmScope.id.toString() }),
    ...(searchType && { type: searchType }),
  })

  return await getRequest(`/api/search?${params.toString()}`)
}

export const searchBlizzard = async <T>(
  terms: string,
  realmScope?: wowaudit.Realm,
  searchType?: 'character' | 'guild' | 'community',
): Promise<{ results: T[]; jobIds: string[] }> => {
  const params = new URLSearchParams({
    terms,
    ...(realmScope && { realm_id: realmScope.id.toString() }),
    ...(searchType && { type: searchType }),
  })

  return await getRequest(`/api/search/blizzard?${params.toString()}`)
}

export const prepareOnboardingGuild = async (
  terms: string,
  realm: wowaudit.Realm,
): Promise<{ guild: wowaudit.GuildReference | null; job_id?: string }> => {
  return await postRequest('/api/search/prepare_guild', {
    terms,
    realmId: realm.id,
  })
}

export const getEntityFromBlizzard = async <T>(
  name: string,
  realmName: string,
  region: string,
  type: 'character' | 'guild',
): Promise<{ results: T[]; jobIds: string[] }> => {
  return await getRequest(
    `/api/search/blizzard?terms=${name}&realm_name=${realmName}&region=${region}&type=${capitalize(
      type,
    )}`,
  )
}
